module.exports = __webpack_public_path__ + "img/Picture2opt.6eeb8ade.jpg";